import {HelpRounded} from '@mui/icons-material'
import {shoppingCart as textsShoppingCart, itemBag as textsItemBag} from '../../../translate/Translate.jsx'
import './questions.scss'
import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'

const Questions = ({onClick}) => {
    const questions = getLocal('questions', [])
    if (!questions.length) return <div/>
    return <div className={'questions'}>
        <div className={'div-questions'}>
            <div className={'div-descriptions'}>
                <HelpRounded className={'icon'}/>
                <div className={'descriptions'}>
                    <label className={'title'}>
                        {textsShoppingCart.questions}
                    </label>
                    <label className={'description'}>
                        {questions?.[0]?.question}
                    </label>
                </div>
            </div>
            <div className={'button'} onClick={() => onClick('questions')}>
                <label className={'label'}>
                    {textsItemBag.toAlter}
                </label>
            </div>
        </div>
    </div>
}

export default Questions
